import { Radio } from '@mantine/core';
import { DatePickerInput, DateValue } from '@mantine/dates';
import { Calendar, CalendarClock } from 'lucide-react';

import Icon from '@/components/Icon.tsx';

import { ChainPlanningMode } from '@/models/appointment/AppointmentChainConfig.ts';

import { useBookingStore } from '@/stores/bookingStore.ts';

import { dayjs } from '@/utils/dayjsSetup.ts';

export const ChainPlanningSelector = () => {
    const startDate = useBookingStore((state) => state.chain_selection.start_date);
    const planningMode = useBookingStore((state) => state.chain_selection.planning_mode);
    const setChainStartDate = useBookingStore((state) => state.setChainStartDate);
    const setChainPlanningMode = useBookingStore((state) => state.setChainPlanningMode);

    const handlePlanningModeChange = (value: string): void => {
        setChainPlanningMode(value as ChainPlanningMode);
    };

    const handleStartDateChange = (value: DateValue): void => {
        setChainStartDate(value ? dayjs(value).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD'));
    };

    return (
        <Radio.Group label="Planung" value={planningMode ?? ChainPlanningMode.AUTO} onChange={handlePlanningModeChange}>
            <div className="mt-1 flex items-start gap-3">
                <Radio.Card
                    value={ChainPlanningMode.AUTO}
                    className="flex-1 cursor-pointer rounded-lg border bg-white p-3 data-[checked]:border-primary"
                >
                    <div className="flex items-center gap-3">
                        <Radio.Indicator />
                        <Icon icon={CalendarClock} size="size-4" />
                        <span className="text-sm font-medium">Auto-Vorschlag</span>
                    </div>
                </Radio.Card>

                <Radio.Card
                    value={ChainPlanningMode.MANUAL}
                    className="flex-1 cursor-pointer rounded-lg border bg-white p-3 data-[checked]:border-primary"
                >
                    <div className="flex flex-col gap-2">
                        <div className="flex items-center gap-3">
                            <Radio.Indicator />
                            <Icon icon={Calendar} size="size-4" />
                            <span className="text-sm font-medium">Startdatum wählen</span>
                        </div>
                        {planningMode === ChainPlanningMode.MANUAL && (
                            <DatePickerInput
                                locale="de"
                                placeholder="Datum wählen"
                                minDate={dayjs().toDate()}
                                value={dayjs(startDate).toDate()}
                                onChange={handleStartDateChange}
                            />
                        )}
                    </div>
                </Radio.Card>
            </div>
        </Radio.Group>
    );
};
